"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalEnum = void 0;
var ModalEnum = exports.ModalEnum = {
  'OFFER_CREATE': 'CreateOfferModal',
  'OFFER_REVIEW': 'ReviewOfferModal',
  'CLOSE_DISPUTE_BUYER': 'CloseDisputeBuyerModal',
  'CLOSE_DISPUTE_SELLER': 'CloseDisputeSellerModal'
};